__turbopack_context__.v({
  "container": "Cards-module-scss-module__IUI7La__container",
});
